export const form_data = {
  name: "Dịch vụ khác",
  description: "Dịch vụ khác",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người yêu cầu",
          fields: [
            [
              {
                name: "Họ tên",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Nội dung yêu cầu",
          fields: [
            [
              {
                name: "Mô tả nội dung yêu cầu",
                value: "",
                type: "text",
                required: false,
                textarea: true,
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Tài liệu gửi kèm (nếu có)",
                value: null,
                type: "pdf",
                span: 2,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký nhãn hiệu
export const dang_ky_nhan_hieu = {
  name: "đăng ký nhãn hiệu",
  description: "Đăng ký nhãn hiệu",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Danh mục hàng hóa/dịch vụ",
          fields: [
            [
              {
                name: "Tên nhóm",
                value: "",
                type: "select",
                required: true,
                span: 1,
              },
              {
                name: "Tên hàng hóa/dịch vụ",
                value: "",
                type: "text",
                required: true,
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Mẫu logo, nhãn hiệu",
                value: null,
                type: "image",
                span: 1,
                maxValue: 5,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký kiểu dáng công nghiệp
export const dang_ky_kieu_dang_cong_nghiep = {
  name: "Đăng ký kiểu dáng công nghiệp",
  description: "Đăng ký kiểu dáng công nghiệp",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Tác giả kiểu dáng công nghiệp",
          fields: [
            [
              {
                name: "Tên tác giả",
                value: "",
                type: "text",
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
              },
              {
                name: "Quốc tịch",
                value: "",
                type: "text",
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Kiểu dáng công nghiệp",
          fields: [
            [
              {
                name: "Phân loại",
                value: "",
                type: "text",
                required: true,
                span: 1,
              },
              {
                name: "Tên kiểu dáng công nghiệp",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản mô tả kiểu dáng công nghiệp",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bộ ảnh chụp/bản vẽ",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 5,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký sáng chế giải pháp hữu ích
export const dang_ky_sang_che_giai_phap_huu_ich = {
  name: "Đăng ký sáng chế / giải pháp hữu ích",
  description: "Đăng ký sáng chế/giải pháp hữu ích",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Tác giả sáng chế/giải pháp hữu ích",
          fields: [
            [
              {
                name: "Tên tác giả",
                value: "",
                type: "text",
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
              },
              {
                name: "Quốc tịch",
                value: "",
                type: "text",
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Sáng chế/giải pháp hữu ích",
          fields: [
            [
              {
                name: "Phân loại (nếu có)",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Tên sáng chế/giải pháp hữu ích (nếu có)",
                value: "",
                type: "text",
                span: 2,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản mô tả",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản vẽ kỹ thuật",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 5,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký gia hạn
export const dang_ky_gia_han = {
  name: "Đăng ký gia hạn",
  description: "Đăng ký gia hạn",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Danh sách văn bằng gia hạn",
          fields: [
            [
              {
                name: "Số văn bằng",
                value: "",
                type: "text",
              },
              {
                name: "Ghi chú (nếu có)",
                value: "",
                type: "text",
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản scan văn bằng gia hạn",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký sửa đổi đơn/ văn bằng
export const dang_ky_sua_doi_don_van_bang = {
  name: "Đăng ký sửa đổi đơn/văn bằng",
  description: "Đăng ký sửa đổi đơn/văn bằng",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Danh sách đơn/văn bằng sửa đổi",
          fields: [
            [
              {
                name: "Số văn bằng/số đơn",
                value: "",
                type: "text",
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Thông tin sửa đổi",
          fields: [
            [
              {
                name: "Tên cần sửa thành",
                value: "",
                type: "text",
              },
              {
                name: "Địa chỉ cần sửa thành",
                value: "",
                type: "text",
              },
              {
                name: "Nội dung sửa đổi khác",
                value: "",
                type: "text",
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản scan văn bằng sửa đổi",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Chuyển giao, chuyển nhượng đơn/văn bằng
export const chuyen_giao_chuyen_nhuong_don_van_bang = {
  name: "Chuyển giao, chuyển nhượng đơn/văn bằng",
  description: "Chuyển giao, chuyển nhượng đơn/văn bằng",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn (bên chuyển giao, chuyển nhượng)",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Bên nhận chuyển giao, chuyển nhượng",
          fields: [
            [
              {
                name: "Tên",
                value: "",
                type: "text",
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Danh sách đơn/văn bằng chuyển giao, chuyển nhượng",
          fields: [
            [
              {
                name: "Số văn bằng/số đơn",
                value: "",
                type: "text",
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Bản scan văn bằng chuyển nhượng",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Tra cứu thông tin
export const tra_cuu_thong_tin = {
  name: "Tra cứu thông tin",
  description: "Tra cứu thông tin",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người nộp đơn",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Nội dung yêu cầu tra cứu",
          fields: [
            [
              {
                name: "Nhóm",
                value: "",
                type: "text",
                required: true,

                span: 1,
              },
              {
                name: "Tên hàng hóa/dịch vụ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Mẫu logo, nhãn hiệu",
                value: null,
                type: "image",
                span: 2,
                maxValue: 1,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Đăng ký bản quyền
export const dang_ky_ban_quyen = {
  name: "Đăng ký bản quyền",
  description: "Đăng ký bản quyền",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Chủ sở hữu",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tác giả bản quyền",
          fields: [
            [
              {
                name: "Tên tác giả",
                value: "",
                type: "text",
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Tác phẩm",
          fields: [
            [
              {
                name: "Loại hình tác phẩm",
                value: "",
                type: "text",
                required: false,
                span: 1,
              },
              {
                name: "Tên tác phẩm",
                value: "",
                type: "text",
                required: false,
                span: 1,
              },
              // {
              //   name: "Mô tả nội dung chính của tác phẩm",
              //   value: "",
              //   type: "text",
              //   required: false,
              //   textarea: true,
              //   span: 1,
              // },
            ],
          ],
          add: true,
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 3,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Giấy ủy quyền",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Tác phẩm",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
              {
                name: "Tài liệu pháp lý",
                value: null,
                type: "pdf",
                span: 1,
                maxValue: 1,
              },
            ],
          ],
        },
      ],
    },
  ],
};

//Dịch vụ khác
export const dich_vu_khac = {
  name: "Dịch vụ khác",
  description: "Dịch vụ khác",
  profiles: [
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Người yêu cầu",
          fields: [
            [
              {
                name: "Tên chủ đơn",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Địa chỉ",
                value: "",
                type: "text",
                required: true,
                span: 2,
              },
              {
                name: "Số điện thoại",
                value: "",
                type: "text",
                span: 1,
              },
              {
                name: "Email",
                value: "",
                type: "text",
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 1,
          type: "Nội dung yêu cầu",
          fields: [
            [
              {
                name: "Mô tả nội dung yêu cầu",
                value: "",
                type: "text",
                required: false,
                textarea: true,
                span: 1,
              },
            ],
          ],
        },
      ],
    },
    {
      cols: 1,
      data: [
        {
          cols: 2,
          type: "Tài liệu gửi kèm (nếu có)",
          fields: [
            [
              {
                name: "Tài liệu gửi kèm",
                value: null,
                type: "pdf",
                span: 2,
                maxValue: 5,
              },
            ],
          ],
        },
      ],
    },
  ],
};
